var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"mb-1",staticStyle:{"margin":"0 auto"},attrs:{"max-width":"800px","flat":""}},[_c('v-card-text',{staticClass:"px-0"},[(_vm.load_flg == true)?_c(_setup.Confirm):_c(_setup.Load)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }